const variablePageSize = 100;
export { variablePageSize };
